/**
 * authStore.js
 * Zustand store for authentication state
 *
 * Persists auth state to localStorage (metadata only, no tokens - Catalyst uses HTTPOnly cookies)
 * State shape:
 *   - user: { id, email, firstName, lastName } | null
 *   - isAuthenticated: boolean
 *   - isLoading: boolean (true during initial session check)
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAuthStore = create(
  persist(
    (set) => ({
      // State
      user: null,
      isAuthenticated: false,
      isLoading: true, // Start as true, useAuth hook will set to false after session check

      // Actions
      setUser: (user) => set({
        user,
        isAuthenticated: !!user,
        isLoading: false,
      }),

      clearUser: () => set({
        user: null,
        isAuthenticated: false,
        isLoading: false,
      }),

      setLoading: (isLoading) => set({ isLoading }),
    }),
    {
      name: 'speech-coach-auth', // localStorage key
      // Only persist user metadata (not loading state)
      partialize: (state) => ({
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

export default useAuthStore;
